import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { trackPartnerRegisterStarted } from 'register-partners-js/utils/consent-ab';

export default class WelcomeNotOwnerRoute extends Route {
  mainLayout = MainLayout;

  @service segment;

  activate() {
    let {
      partnerName,
      organizationLegalCountry = 'FR',
      legalFlow = 'company_creation',
      organizationId,
    } = this.modelFor('welcome').redirection;

    trackPartnerRegisterStarted(this.segment, {
      organizationLegalCountry,
      legalFlow,
      organizationId,
      partnerName,
    });
    this.segment.track('onboarding_partner_register_eligibility_denied', {
      denial_reason: 'not_shareholder',
    });
  }
}
